import { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/multiselect/index.ts
const ms = componentCommon.multiselect;
const msDeep = tDeep(ms);

export const MultiselectTelekomDT: MultiSelectDesignTokens = {
  root: {
    background: t(ms.background),
    disabledBackground: t(ms.disabled.background),
    filledBackground: t(ms.filled.background),
    filledHoverBackground: t(ms.filled.hover.background),
    filledFocusBackground: t(ms.filled.focus.background),
    borderColor: t(ms.border.color),
    hoverBorderColor: t(ms.hover.border.color),
    focusBorderColor: t(ms.focus.border.color),
    invalidBorderColor: t(ms.invalid.border.color),
    color: t(ms.color),
    disabledColor: t(ms.disabled.color),
    placeholderColor: t(ms.placeholder.color),
    invalidPlaceholderColor: t(ms.invalid.placeholder.color),
    paddingX: t(ms.padding.x),
    paddingY: t(ms.padding.y),
    borderRadius: t(ms.border.radius),
    focusRing: {
      width: t(ms.focus.ring.width),
      color: t(ms.focus.ring.color),
      offset: t(ms.focus.ring.offset),
    },
    sm: {
      fontSize: t(ms.sm.font.size),
      paddingX: t(ms.sm.padding.x),
      paddingY: t(ms.sm.padding.y),
    },
    lg: {
      fontSize: t(ms.lg.font.size),
      paddingX: t(ms.lg.padding.x),
      paddingY: t(ms.lg.padding.y),
    },
  },
  dropdown: {
    width: t(ms.dropdown.width),
    color: t(ms.dropdown.color),
  },
  overlay: {
    background: t(ms.overlay.background),
    borderColor: t(ms.overlay.border.color),
    borderRadius: t(ms.overlay.border.radius),
    color: t(ms.overlay.color),
  },
  list: {
    gap: t(ms.list.gap),
    padding: `${msDeep.list.padding.y} ${msDeep.list.padding.x}`,
    header: {
      padding: `${msDeep.list.header.padding.top} ${msDeep.list.header.padding.right} ${msDeep.list.header.padding.bottom} ${msDeep.list.header.padding.left}`,
    },
  },
  option: {
    focusBackground: t(ms.option.focus.background),
    selectedBackground: t(ms.option.selected.background),
    selectedFocusBackground: t(ms.option.selected.focus.background),
    color: t(ms.option.color),
    focusColor: t(ms.option.focus.color),
    selectedColor: t(ms.option.selected.color),
    selectedFocusColor: t(ms.option.selected.focus.color),
    padding: `${msDeep.option.padding.y} ${msDeep.option.padding.x}`,
    borderRadius: t(ms.option.border.radius),
    gap: t(ms.option.gap),
  },
  optionGroup: {
    background: t(ms.option.group.background),
    color: t(ms.option.group.color),
    fontWeight: t(ms.option.group.font.weight),
    padding: `${msDeep.option.group.padding.y} ${msDeep.option.group.padding.x}`,
  },
  clearIcon: {
    color: t(ms.clear.icon.color),
  },
  chip: {
    borderRadius: t(ms.chip.border.radius),
  },
};
